import React from 'react'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DateTime as DateTimeLuxon } from 'luxon'
import {
  BadgeStatusPallet,
  Btn,
  CustomPanel,
  InputNumeroInteiro,
  InputText,
  PageHeader,
  SectionTitle,
} from '../../../../components'
import useRastreabilidadePallet, { LOAD_MESSAGE } from './RastreabilidadePalletHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Card } from 'primereact/card'
import { SplitButton } from 'primereact/splitbutton'
import { tableCellCentered } from '../../../../assets/js/styles'
import { vinho } from '../../../../assets/js/colors'

function TimelineSection({ timeline }) {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle title={'Timeline'} />
      </div>
      {timeline.length === 0 && (
        <div className="p-col-12" style={{ color: '#c4c4c4', fontStyle: 'italic' }}>
          Não existem eventos registrados para este pallet
        </div>
      )}
      {timeline.map((evento, index) => {
        const { status, prev_status, created_at, description, user } = evento
        return (
          <div className="p-col-12" key={index}>
            <Card style={{ paddingTop: 10, paddingBottom: 10 }}>
              <div style={{ display: 'flex' }}>
                <div
                  style={{
                    width: 300,
                    minWidth: 300,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 6,
                  }}
                >
                  {prev_status && (
                    <>
                      <BadgeStatusPallet status={prev_status} />
                      <span style={{ color: '#c4c4c4' }}>➜</span>
                    </>
                  )}
                  <BadgeStatusPallet status={status} />
                </div>
                <div>
                  <div style={{ fontSize: '0.7rem', color: vinho, fontStyle: 'italic' }}>
                    {DateTimeLuxon.fromISO(created_at).toFormat('dd/MM/yyyy HH:mm')}
                  </div>
                  <div>{description}</div>
                  <div style={{ fontSize: '0.7rem', color: '#c4c4c4', fontStyle: 'italic' }}>
                    {user}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        )
      })}
    </div>
  )
}

function RastreabilidadePallet({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = useRastreabilidadePallet()

  const splitButtonsItems = [
    {
      label: 'Tag Pallet c/ Grupo Produto',
      command: () => localDispatch.onBtnGerarTagPalletGrupoProdutoSingle(state.palletNumber),
    },
  ]

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.TRACKING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPalletInfos(selectedTp, state.palletNumber)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Avisos não invalidam o rastreio exibido, então não resetam o state
  useEffect(() => {
    if (state.warningMessage) {
      dispatch(showMessageBox(null, state.warningMessage))
      localDispatch.clearWarningMessage()
    }
  }, [state.warningMessage])

  return (
    <>
      <PageHeader>3.14 - Rastreabilidade Pallet - Entrega</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={() => history.goBack()}>
          <div>
            <SectionTitle title={'Digite o número do Pallet desejado'} />
            <section className="p-grid">
              <div className="p-col-3">
                <InputNumeroInteiro
                  value={state.palletNumber}
                  onChange={value => localDispatch.onChange(value)}
                  label="Numero do Pallet:"
                />
              </div>
              <div className="p-col-6" style={{ paddingTop: 45, display: 'flex', gap: 8 }}>
                <Btn onClick={() => localDispatch.onBtnClicked(selectedTp, state.palletNumber)}>
                  Rastrear
                </Btn>
                {state.pallet.status !== '' && (
                  <SplitButton
                    menuStyle={{ width: 340 }}
                    className="bck-primary"
                    label="Tag Pallet"
                    icon="pi pi-tags"
                    onClick={() => localDispatch.onBtnGerarTagPalletSingle(state.palletNumber)}
                    model={splitButtonsItems}
                  ></SplitButton>
                )}
              </div>
            </section>
          </div>

          {state.pallet.status !== '' ? (
            <div>
              <div className="p-grid">
                <div className="p-col-12">
                  <SectionTitle title={'Informações'} />
                </div>
                <div className="p-col-6">
                  <InputText
                    label={'Picking :'}
                    type="text"
                    value={`${state.pallet.picking_id}: ${state.pallet.picking_name}`}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>
                <div className="p-col-3">
                  <InputText
                    label={'Area de Separação :'}
                    type="text"
                    value={state.pallet.pickingarea_name}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>
                <div className="p-col-3">
                  <InputText
                    label={'Status :'}
                    type="text"
                    value={state.pallet.status}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>
                <div className="p-col-6">
                  <InputText
                    label={'Posição Estoque :'}
                    type="text"
                    value={state.pallet.endereco || ''}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>
                <div className="p-col-3">
                  <InputText
                    label={'Estoque :'}
                    type="text"
                    value={state.pallet.estoque || ''}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>
                <div className="p-col-3">
                  <InputText
                    label={'Qte de Caixas:'}
                    type="text"
                    value={state.pallet.qte_caixas}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>
                <div className="p-col-3">
                  <InputText
                    label={'Criado em:'}
                    type="text"
                    value={state.pallet.created_at}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>

                <div className="p-col-3">
                  <InputText
                    label={'Placa do Veiculo :'}
                    type="text"
                    value={state.pallet.vehicle_badge}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>
                <div className="p-col-3">
                  <InputText
                    label={'Motorista :'}
                    type="text"
                    value={state.pallet.driver_name}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>
                <div className="p-col-3">
                  <InputText
                    label={'Empresa :'}
                    type="text"
                    value={state.pallet.company_name}
                    onChange={value => localDispatch.onChange(value)}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="p-grid">
                {state.pallet.movimentacoes && state.pallet.movimentacoes.length > 0 && (
                  <>
                    <div className="p-col-12">
                      <SectionTitle title={'Movimentações do Pallet'} />
                    </div>
                    <div className="p-col-12" style={{ marginBottom: -10 }}>
                      <p>Internação no Estoque:</p>
                    </div>
                    <div className="p-col-6">
                      <InputText
                        label={'Data:'}
                        type="text"
                        value={
                          new Date(
                            state.pallet.movimentacoes[
                              state.pallet.movimentacoes.length - 1
                            ].data_movimentacao,
                          ).toLocaleDateString('pt-BR') || ''
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="p-col-6">
                      <InputText
                        label={'Usuário:'}
                        type="text"
                        value={
                          state.pallet.movimentacoes[state.pallet.movimentacoes.length - 1]
                            .usuario || ''
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="p-col-12" style={{ marginBottom: -10 }}>
                      <p>Última movimentação:</p>
                    </div>
                    <div className="p-col-4">
                      <InputText
                        label={'Tipo:'}
                        type="text"
                        value={state.pallet.movimentacoes[0].movimentacao_type || ''}
                        disabled={true}
                      />
                    </div>
                    <div className="p-col-4">
                      <InputText
                        label={'Data:'}
                        type="text"
                        value={
                          new Date(
                            state.pallet.movimentacoes[0].data_movimentacao,
                          ).toLocaleDateString('pt-BR') || ''
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="p-col-4">
                      <InputText
                        label={'Usuário:'}
                        type="text"
                        value={state.pallet.movimentacoes[0].usuario || ''}
                        disabled={true}
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="p-grid">
                <div className="p-col-12">
                  <SectionTitle title={'Items do Pallet'} />
                </div>
                <div className="p-col-12">
                  <DataTable
                    value={state.pallet.items}
                    emptyMessage="Não existem itens neste pallet"
                    rows={5}
                    paginator={true}
                  >
                    <Column field="product_code" header="Código" style={tableCellCentered(180)} />
                    <Column field="product_name" header="Produto" />
                    <Column field="biped_by" header="Quem bipou" style={tableCellCentered(130)} />
                    <Column field="qte_biped" header="Quantidade" style={tableCellCentered(130)} />
                    <Column
                      field="identifier"
                      header="Identificador"
                      style={tableCellCentered(130)}
                    />
                    <Column
                      field="invoice_number"
                      header="Número NF"
                      style={tableCellCentered(130)}
                    />
                  </DataTable>
                </div>
              </div>
              <TimelineSection timeline={state.timeline} />
            </div>
          ) : (
            <div></div>
          )}

          {state.palletExcluido && (
            <div>
              <div className="p-grid">
                <div className="p-col-12">
                  <SectionTitle title={'Situação'} />
                </div>
                <div className="p-col-12">
                  <div
                    style={{
                      display: 'inline-block',
                      backgroundColor: vinho,
                      color: 'white',
                      padding: '6px 16px',
                      borderRadius: 15,
                      fontWeight: 'bold',
                    }}
                  >
                    PALLET EXCLUÍDO
                  </div>
                  <div style={{ marginTop: 8, color: '#c4c4c4', fontStyle: 'italic' }}>
                    Este pallet foi excluído do sistema. O histórico de status registrado está na
                    timeline abaixo.
                  </div>
                </div>
              </div>
              <TimelineSection timeline={state.timeline} />
            </div>
          )}
        </CustomPanel>
      </div>
    </>
  )
}

const mapStateToProp = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProp)(withRouter(RastreabilidadePallet))
